import { InjectionToken } from '@angular/core';

export const RUNTIME_CONFIG_PATH = new InjectionToken<string>('RUNTIME_CONFIG_PATH');
